module.exports = __webpack_public_path__ + "img/Noctiluca-Process-7-mobile.fa526ef4.png";